module.exports = __webpack_public_path__ + "img/gcCar_pc.de920492.png";